// Accessibility attribute tweaks (vanilla JS; previously jQuery).
// Loaded with `defer`, so the DOM is parsed by the time this runs.
function setAttrAll(selector, name, value) {
  document.querySelectorAll(selector).forEach(function (el) {
    el.setAttribute(name, value);
  });
}

setAttrAll('.klaviyo-bis__email', 'aria-label', 'Email');
setAttrAll('.materials-richtext .rich-text__blocks h2.rich-text__heading.rte.h1', 'aria-level', '1');
setAttrAll('.capsulewardrobes-page .rich-text__blocks h2.rich-text__heading.rte.h1', 'aria-level', '1');
setAttrAll('.story-page .rich-text__blocks h2.rich-text__heading.rte.h1', 'aria-level', '1');
setAttrAll("a[href='https://www.tencel.com/luxe']", 'aria-label', 'You will depart from bleusalt.com and go to https://www.tencel.com/luxe.');
setAttrAll(".home-learn-more a[href='/pages/materials']", 'aria-label', 'Learn More, Essentials sustainably made in the USA from the softest fibers on earth');
setAttrAll('.three-cate ul li .media img', 'aria-hidden', 'true');
setAttrAll('.three-cate ul li h2', 'aria-hidden', 'true');
